export const urls = {
  home: "/",
  liveTv: "/live-tv",
  movies: "/movies",
  tvShows: "/tv-shows",
  watchlist: "/watchlist",
  settings: "/settings",
  movieWatch: "/movies/watch/:id",
  seriesWatch: "/tv-shows/watch/:id",
  search: "/search",
}
